export enum Reason {
  INVALID_OWNER = 0,
  INVALID_VEHICLE = 1,
}
